<template>
  <div class="detail">
    <div class="head">
      <span>当前订单状态：{{['待审核', '待发货', '已发货', '已完成', '已取消'][detailList.status]}}</span>
    </div>
    <div class="main">
      <div class="main-head">
        <span
          :class="currentIndex == index ? 'active' : ''"
          @click="changeIndex(index)"
          v-for="(item,index) in tabData"
          :key="index"
        >{{item}}</span>
      </div>
      <div class="shouhuo" v-if="this.currentIndex == 0">
        <div class="main-info">
          <div class="person-info">
            <p>收货人信息</p>
            <p>收货人： {{detailList.username}}</p>
            <p>地址：{{detailList.province}} {{detailList.city}} {{detailList.district}} {{detailList.address}}</p>
            <p>公司：{{detailList.company}}</p>
            <p>手机号：{{detailList.mobile}}</p>
          </div>
          <div class="payload-info">
            <p>申请时间：{{detailList.create_time}}</p>
            <p>研究课题：{{detailList.subject}}</p>
            <p>年使用量：{{detailList.annual_usage}}</p>
            <p>需求备注：{{detailList.remark}}</p>
            <p>目前使用品牌：{{detailList.brand}}</p>
          </div>
        </div>
        <div class="main-table">
          <table>
            <thead>
              <tr>
                <th>商品货号</th>
                <th>商品名称</th>
                <th>商品规格</th>
                <th>商品数量</th>
              </tr>
            </thead>
            <tbody>
              <div v-for="(item,index) in detailList.goods" :key="index">
                <tr>
                  <td class="goods_code" @click="goxqs(item.goods_code)">{{item.goods_code}}</td>
                  <td>
                    <p>{{item.goods_name}}</p>
                    <p>英文名称：{{item.goods_name_en}}</p>
                  </td>
                  <td>{{item.sku}}</td>
                  <td>{{item.num}}</td>
                </tr>
                <div class="attribute">
                  <p>
                    <span>商品属性：<span>{{item.attribute}}</span></span>
                    <span>运输方式：<span>{{item.transport}}</span></span>
                    <span>储存条件：<span>{{item.storage}}</span></span>
                    <span>保质期：<span>{{item.life}}</span></span>
                  </p>
                </div>
              </div>
            </tbody>
          </table>
        </div>
        <div class="payload" v-if="this.detailList.freight > 0">
          <span>
            运输包装费:
            <span>{{this.detailList.freight}}</span> 元
          </span>
        </div>
      </div>
      <div class="wuliu" v-if="this.currentIndex == 1">
        <div class="wuliu-head">
          <p>快递公司： {{detailList.express}}</p>
          <p>快递单号： {{detailList.express_number}}</p>
        </div>
        <div class="wuliu-main"></div>
        <div class="line"></div>
        <div class="bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabData: ["订单信息", "物流信息"],
      currentIndex: 0,
      detailList: [],
      order_number: this.$route.query.order_number
    };
  },
  methods: {
    changeIndex(index) {
      this.currentIndex = index;
    },
    getdetailData() {
      this.$api.tryApply
        .applyDetail({
          trial_number: this.order_number
        })
        .then(res => {
          this.detailList = res.data;
        });
    },
    goxqs(id) {
      this.$router.push({
        path: `/homepage/detail`,
        query: {
          id: id
        }
      });
    }
  },
  created() {
    if (this.$route.query.order_number) {
      this.getdetailData();
      if (this.$route.query.flag) {
        this.currentIndex = 1;
      } else {
        this.currentIndex = 0;
      }
    } else {
    }
  }
};
</script>

<style lang="less" scoped>
.head {
  width: 876px;
  min-height: 60px;
  background: #dee5ec;
  border: 1px solid #003871;
  position: relative;
  span {
    font-size: 14px;
    color: #333333;
    position: absolute;
    left: 21px;
    top: 21px;
  }
}
.goods_code {
  color: #a52a2a;
  text-decoration-line: underline;
  cursor: pointer;
}
.newPrice {
  .old {
    text-decoration: line-through;
    display: block;
  }
  .new {
    color: #a52a2a;
  }
}
.main {
  width: 876px;
  border: 1px solid #003871;
  .main-head {
    min-height: 60px;
    position: relative;
    margin-left: 26px;
    span {
      cursor: pointer;
      width: 130px;
      height: 34px;
      background: #dee5ec;
      position: absolute;
      text-align: center;
      line-height: 34px;
      margin-top: 25px;
      &:nth-child(2) {
        margin-left: 160px;
      }
      &.active {
        background: #fff;
        border: 1px solid #003871;
      }
    }
  }
  .main-info {
    width: 100%;
    display: flex;
    font-size: 12px;
    color: #666666;
    line-height: 24px;
    margin-top: 10px;
    .person-info {
      width: 459px;
      margin-left: 26px;
    }
    .payload-info {
      width: 240px;
      margin-left: 22px;
    }
  }
  .main-table {
    margin-top: 24px;
    width: 820px;
    margin: auto;
    table {
      width: 820px;
      height: 116px;
      margin: 20px 0px;
      tr {
        position: relative;
        display: flex;
      }
      th,
      td {
        &:nth-child(1) {
          left: 32px;
        }
        &:nth-child(2) {
          left: 155px;
          p {
            margin-bottom: 5px;
          }
        }
        &:nth-child(3) {
          left: 555px;
        }
        &:nth-child(4) {
          left: 655px;
        }
      }
      th {
        position: absolute;
        top: 12px;
      }
      td {
        position: absolute;
        top: 22px;
        font-size: 14px;
        &:nth-child(2) {
          position: absolute;
          top: 12px;
        }
      }
    }
    thead {
      width: 820px;
      background: #f5f5f5;
      border: 1px solid #dddddd;
      tr {
        width: 820px;
        height: 38px;
      }
    }
    tbody {
      tr {
        width: 820px;
        min-height: 60px;
        border: 1px solid #dddddd;
        border-top: none;
        border-bottom:none;
      }
    }
  }
  .payload {
    min-height: 24px;
    width: 820px;
    margin: auto;
    text-align: right;
    margin-top: 26px;
    span {
      font-size: 12px;
      color: #333333;
      span {
        color: #003871;
        font-size: 24px;
        font-weight: 600;
      }
    }
  }
  .wuliu-head {
    margin-left: 27px;
    margin-top: 20px;
    p {
      margin-top: 10px;
    }
  }
}
.attribute{
  border:1px solid #ccc;
  border-top:none;
  p{
    padding:15px;
  }
  span{
    margin-right: 20px;
    span{
      color:#999
    }
  }
}
</style>
